import * as Yup from 'yup';
import {
  MESSAGE_FULL_NAME_REQUIRED,
  MESSAGE_ONLY_CYRILLIC_SYMBOLS,
  MESSAGE_REQUIRED,
  allowedFullNameCharsRegExp,
  fullNameRegExp,
} from '@/utils/validation-utils';

export const fullNameSchema: Yup.StringSchema = Yup.string()
  .required(MESSAGE_REQUIRED)
  .matches(allowedFullNameCharsRegExp, MESSAGE_ONLY_CYRILLIC_SYMBOLS)
  .matches(fullNameRegExp, MESSAGE_FULL_NAME_REQUIRED);
